import * as tslib_1 from "tslib";

var commonCardStyles = function commonCardStyles(props) {
  var theme = props.theme;
  var effects = theme.effects;
  return {
    border: 'none',
    boxShadow: effects.elevation16,
    borderRadius: effects.roundedCorner2,
    selectors: {
      '.ms-Callout-main': {
        borderRadius: effects.roundedCorner2
      }
    }
  };
};

export var ExpandingCardStyles = function ExpandingCardStyles(props) {
  return {
    root: tslib_1.__assign({}, commonCardStyles(props), {
      width: 320
    }),
    expandedCard: {
      selectors: {
        ':before': {
          width: 272 // needs to change due to above change

        }
      }
    }
  };
};
export var PlainCardStyles = function PlainCardStyles(props) {
  return {
    root: tslib_1.__assign({}, commonCardStyles(props))
  };
};